export default __webpack_public_path__ + "images/3_Trumf_saldo.webp";